import React from 'react';
import { useState } from 'preact/hooks';
import {  Button, App } from "antd"
import { TextCustom,TextHeadTitle } from "../../../components/text"
import { CopyOutlined } from '@ant-design/icons';
import noImag from "../../../assets/images/no-image.svg"
import { ConfirmInfo } from '../component/confirminfo';
import { Recommendations } from '../component/recommendations';
import { useMediaQuery } from 'react-responsive';
import { color } from '../../../resources';

export const StepConfirm = ({ data }) => {
  const { message } = App.useApp();
  const [copied, setCopied] = useState(false);
  const { bookingId,estimation } = data
  const isMobile = useMediaQuery({ maxWidth: 767 });

  const handleCopy = () => {
    navigator.clipboard.writeText(bookingId);
    setCopied(true);
    message.success('Copied to clipboard');
  };


  return (
    <div>
      {!bookingId && <div style={{ textAlign: 'center' }}>
        <TextHeadTitle text={"กรุณาตรวจสอบข้อมูล"}  bold align={"center"}  />
        <TextCustom text={'(กดยืนยันด้านล่าง เพื่อล็อคราคานี้ไว้)'} size={"18px"}styled={{ marginBottom: '10px' }} />
        {/* <img src={estimation?.phoneImage || noImag} style={{ width: isMobile?'80%':'20%' }}  /> */}
        <TextCustom text={estimation?.name} size={"32px"} color={color.black_grey} bold />
      </div>}
      {/* {bookingId && <div style={{ textAlign: 'center' }}>
        <TextHeadTitle text={"การนัดหมายสำเร็จ"} bold align={"center"} styled={{ marginBottom: '12px' }} />
        <TextCustom text={"การนัดหมายของท่านเรียบร้อยแล้ว ท่านจะได้รับการติดต่อกลับจากเจ้าหน้าที่ ทางโทรศัพท์ก่อนเวลานัดหมาย ภายใน 24 ชั่วโมง"}
          size={"24px"} color={color.black_grey} />
        <TextCustom text={"หากไม่ได้รับการติดต่อกลับ รบกวนโทร. แจ้งได้ที่ 09-5319-4700"}
          size={"24px"} color={color.black_grey} />
        <div>
          <span className='text-detail'>หมายเลขการนัดหมายของท่านคือ  </span><Button onClick={handleCopy} disabled={copied} className='btn-copy'>
            {copied ? 'คัดลอกสำเร็จ' : bookingId}<CopyOutlined />
          </Button>
          <TextCustom text={"กรุณากด Copy หรือ Capture หน้าจอเพื่อเป็นหลักฐานยืนยันการนัดหมาย"}
          size={"24px"} color={color.red} />
        </div>
      </div>} */}
      <div>
        <ConfirmInfo data={data} />
        <Recommendations />
      </div></div>
  )
}

